// extracted by mini-css-extract-plugin
module.exports = {"root":"CountDown_root__Us9be","top":"CountDown_top__bkn8J","bottom":"CountDown_bottom__VBQNi"};